import { motion } from "framer-motion"
import { Section, Title, WysiwygText } from "components/shared"
import { useAnimation } from "utils/useAnimation"

const Notes = ({ id, notes }) => {
  const { animation } = useAnimation()
  return (
    <>
      <Section className="!pb-12" animate id={id}>
        <Title title="Notes from our doctor" pretitle="General Information" size="sm" width="max" animate />
      </Section>
      {notes.map((note, index) => (
        <Section key={index} className="!py-12 even:bg-blue-200" animate>
          <motion.div className="text-xl font-semibold mb-6" {...animation}>
            {note.title}
          </motion.div>
          <WysiwygText text={note.description} animate />
        </Section>
      ))}
    </>
  )
}

export default Notes
